import React from 'react';
import Header from '../components/Header';
import Dashboard from '../components/Dashboard';
import { mockProductData } from '../utils/mockData';
const Home = () => {
  const productCounts = {
    perfectMatch: mockProductData.filter(p => p.matchCategory === 'perfect-match').length,
    potentialMatch: mockProductData.filter(p => p.matchCategory === 'potential-match').length,
    noMatch: mockProductData.filter(p => p.matchCategory === 'no-match' && !p.skipped).length,
    skipped: mockProductData.filter(p => p.skipped).length
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-743">
      <Header data-id="element-744" />
      <Dashboard productCounts={productCounts} data-id="element-745" />
    </div>;
};
export default Home;